"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("models/globals");
const tools_1 = require("../outils/tools");
class Droits extends webix_jet_1.JetView {
    constructor(app, name, conf) {
        super(app, name);
        this.columnData = conf.columnData;
    }
    config() {
        webix.protoUI({
            name: "edittree"
        }, webix.EditAbility, webix.ui.treetable);
        const tree = {
            id: "droitstree",
            view: "treetable",
            // template : "{common.icon()} {common.checkbox()} {common.folder()} <span>#value#</span>",
            columns: this.columnData,
            threeState: true,
            editable: true,
            editaction: "custom",
            editor: "text",
            editValue: "title",
            select: "row",
            drag: true,
            url: globals_1.phpPath + "droits.php?option=list",
            save: {
                // updateFromResponse:true,         // ça ne marche pas, peut etre parce que success:true ?
                "insert": globals_1.phpPath + "droits.php?option=save",
                "update": globals_1.phpPath + "droits.php?option=save",
                "delete": globals_1.phpPath + "droits.php?option=delete",
            },
            on: {
                "onItemClick": function (id) {
                    let mName = this.$scope.moduleName + ".update";
                    if (((globals_1.lv2.droits).includes(mName))) {
                        // this.editStop();
                        // this.editRow(id);
                        this.editCell(id.row, id.column);
                    }
                },
                onAfterEditStart: function (cell) {
                    let ml = this.getEditor().config.maxlength;
                    if (ml > 0) {
                        this.getEditor().getInputNode().setAttribute("maxlength", ml);
                    }
                },
                onBeforeDrop: function (context) {
                    //aceppt only dnd on data area
                    if (!context.target || !this.getItem(context.target))
                        return false;
                    let parentId = this.getItem(context.target).unid;
                    let source = this.getItem(context.source);
                    source.parentId = parentId;
                    context.parent = context.target;
                    return;
                    // if (this.getItem(context.target).$count && this.getItem(context.target).open){
                    if (this.getItem(context.target).open) {
                        //drop as first child
                        context.index = 0;
                    }
                    else {
                        //drop next
                        context.index++;
                    }
                },
                onAfterDrop: function (context, event) {
                    // webix.message(parentId);
                }
            },
        };
        const buttons = {
            view: "toolbar", padding: 7, "height": 50, borderless: true,
            elements: [
                {
                    view: "icon", icon: "mdi mdi-arrow-collapse-vertical", width: 50,
                    tooltip: (0, globals_1._)("Tout condenser"),
                    click: function () {
                        const tree = $$("droitstree");
                        tree.closeAll();
                    }
                }, {
                    view: "icon", icon: "mdi mdi-arrow-expand-vertical", width: 50,
                    tooltip: (0, globals_1._)("Tout étirer"),
                    click: function () {
                        const tree = $$("droitstree");
                        tree.openAll();
                    }
                }, {
                    view: "button", value: (0, globals_1._)("Ajouter"), width: 200, hidden: true, id: "button-add",
                    click: function () {
                        // const tree = $$("droitstree");
                        let parent = 0;
                        let idparent = 0;
                        let index = 0;
                        const tree = $$("droitstree");
                        if (tree.getSelectedItem(false)) {
                            parent = tree.getSelectedItem(false).id;
                            idparent = tree.getSelectedItem(false).unid;
                            index = tree.getIndexById(parent) + 1;
                        }
                        else {
                            // tree.select(tree.getFirstId());
                        }
                        // tree.open(parent);
                        tree.add({ libelle: (0, globals_1._)("Nouveau"), "parentId": idparent }, 0, String(parent));
                    }
                },
                {
                    view: "button", value: (0, globals_1._)("Supprimer"), width: 200, hidden: true, id: "button-delete",
                    click: function () {
                        const tree = $$("droitstree");
                        let id = tree.getSelectedId(true, true);
                        if (id)
                            tree.remove(id);
                    }
                },
                { view: "icon", icon: "mdi mdi-reload", tooltip: (0, globals_1._)("Actualiser"),
                    click: () => this.reload()
                },
                { view: "icon", icon: "mdi mdi-table-arrow-down", id: "droitsImprimerTableButton", value: "",
                    tooltip: (0, globals_1._)("Générer pdf depuis la liste"),
                    click: () => (0, tools_1.imprimerTable)("droitstree", (0, globals_1._)("Droits Concepteur"))
                },
                {}
            ]
        };
        return ({
            rows: [{
                    cols: [
                        { height: 50, borderless: true, template: (0, globals_1._)("Droits d'accès des utilisateurs"), localId: "title",
                            css: "webix_header app_header", width: 300 },
                        buttons
                    ]
                }, tree
            ]
        });
    }
    reload() {
        const tree = $$("droitstree");
        tree.clearAll();
        tree.load(tree.config.url);
    }
    init() {
        // this.moduleName = "droits";
        this.currentTree = $$("droitstree");
    }
    ready() {
        this.currentTree.attachEvent("onAfterDrop", function (details) {
            this.updateItem(details.start);
        });
        let me = this;
        let dp = webix.dp("droitstree");
        dp.attachEvent("onAfterSave", function (response, id) {
            if (response.type == "delete")
                return;
            let record = me.currentTree.getItem(id);
            // let record = null;
            // if (tree.getSelectedItem()) {
            // 	record = tree.getItem(tree.getNextId(tree.getSelectedId()));
            // } else {
            // 	record = tree.getItem(tree.getFirstId());
            // }
            if (!record.unid) {
                record.unid = response.unid;
            }
        });
        dp.attachEvent("onAfterSaveError", function (id, status, response, details) {
            // TODO me.currentTree.undo(id);
            webix.alert({
                text: (0, globals_1._)("La modification n'est pas enregistrée sur le serveur."),
            });
        });
        if ((globals_1.lv2.droits).includes(this.moduleName + ".insert,"))
            $$("button-add").show();
        if ((globals_1.lv2.droits).includes(this.moduleName + ".delete,"))
            $$("button-delete").show();
    }
}
exports.default = Droits;
